/**
 * HPH Predictive Search
 * Inline dropdown results below the search bar (Vetomall-style).
 * Uses Shopify /search/suggest.json endpoint.
 * Debounced 300ms. Shows products with thumbnail + title + price.
 */

(function () {
  const input = document.getElementById('hph-search-input');
  const results = document.getElementById('hph-search-results');
  const form = document.getElementById('hph-search-form');

  if (!input || !results) return;

  let debounceTimer = null;
  let cache = {};

  function formatMoney(price) {
    var num = parseFloat(price);
    return '$' + num.toFixed(2);
  }

  function close() {
    results.setAttribute('hidden', '');
    while (results.firstChild) results.removeChild(results.firstChild);
  }

  function createResultItem(product) {
    const link = document.createElement('a');
    link.href = product.url;
    link.className = 'hph-search__result';

    var soldOut = product.available === false;
    if (soldOut) link.classList.add('hph-search__result--sold-out');

    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image.replace(/(\.[a-z]+)(\?|$)/, '_100x100$1$2');
      img.alt = '';
      img.className = 'hph-search__result-img';
      img.width = 50;
      img.height = 50;
      img.loading = 'lazy';
      link.appendChild(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'hph-search__result-img hph-search__result-img--empty';
      link.appendChild(placeholder);
    }

    const info = document.createElement('div');
    info.className = 'hph-search__result-info';

    const title = document.createElement('span');
    title.className = 'hph-search__result-title';
    title.textContent = product.title;
    info.appendChild(title);

    if (soldOut) {
      const badge = document.createElement('span');
      badge.className = 'hph-search__result-badge';
      badge.textContent = 'Sold out';
      info.appendChild(badge);
    }

    if (product.price) {
      const price = document.createElement('span');
      price.className = 'hph-search__result-price';
      price.textContent = formatMoney(product.price);
      info.appendChild(price);
    }

    link.appendChild(info);
    return link;
  }

  function renderResults(data) {
    while (results.firstChild) results.removeChild(results.firstChild);

    const products = data.resources.results.products || [];

    if (products.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'hph-search__empty';
      empty.textContent = 'No products found';
      results.appendChild(empty);
      results.removeAttribute('hidden');
      return;
    }

    products.forEach(function (product) {
      results.appendChild(createResultItem(product));
    });

    const viewAll = document.createElement('a');
    viewAll.href = '/search?q=' + encodeURIComponent(input.value) + '&type=product&options[unavailable_products]=show';
    viewAll.className = 'hph-search__view-all';
    viewAll.textContent = 'View all results';
    results.appendChild(viewAll);

    results.removeAttribute('hidden');
  }

  function search(query) {
    if (query.length < 2) {
      close();
      return;
    }

    if (cache[query]) {
      renderResults(cache[query]);
      return;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=show';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        cache[query] = data;
        if (input.value.trim() === query) {
          renderResults(data);
        }
      })
      .catch(function () {
        close();
      });
  }

  /* Clear button (circle X) */
  var clearBtn = document.getElementById('hph-search-clear');
  function toggleClearBtn() {
    if (clearBtn) {
      clearBtn.hidden = input.value.trim().length === 0;
    }
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      toggleClearBtn();
      close();
      input.focus();
    });
  }

  input.addEventListener('input', function () {
    toggleClearBtn();
    clearTimeout(debounceTimer);
    var query = input.value.trim();
    debounceTimer = setTimeout(function () {
      search(query);
    }, 300);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2) {
      search(input.value.trim());
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hph-header__search')) {
      close();
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      close();
      input.blur();
    }
  });

  form.addEventListener('submit', function (e) {
    var query = input.value.trim();
    if (query.length === 0) {
      e.preventDefault();
    }
  });
})();
